import { P } from '~components/Typography';

import { Container } from './styles';

type Props = {
	className?: string;
	count: number;
};

export const UnreadMessagesBadge = ({ className, count }: Props) => (
	<Container className={className}>
		{count > 99 ? <P size="xxsmall">+99</P> : <P size="xsmall">{count}</P>}
	</Container>
);
